import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { URI } from '../../../base/common/uri.js';
import * as resources from '../../../base/common/resources.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { TernarySearchTree } from '../../../base/common/map.js';
export var IWorkspaceContextService = createDecorator('contextService');
export var IWorkspace;

(function (IWorkspace) {
  function isIWorkspace(thing) {
    return !!(thing && typeof thing === 'object' && typeof thing.id === 'string' && Array.isArray(thing.folders));
  }

  IWorkspace.isIWorkspace = isIWorkspace;
})(IWorkspace || (IWorkspace = {}));

export var IWorkspaceFolder;

(function (IWorkspaceFolder) {
  function isIWorkspaceFolder(thing) {
    return !!(thing && typeof thing === 'object' && URI.isUri(thing.uri) && typeof thing.name === 'string' && typeof thing.toResource === 'function');
  }

  IWorkspaceFolder.isIWorkspaceFolder = isIWorkspaceFolder;
})(IWorkspaceFolder || (IWorkspaceFolder = {}));

export var Workspace = /*#__PURE__*/function () {
  function Workspace(_id) {
    var folders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _configuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, Workspace);

    this._id = _id;
    this._configuration = _configuration;
    this._foldersMap = TernarySearchTree.forUris();
    this.folders = folders;
  }

  _createClass(Workspace, [{
    key: "folders",
    get: function get() {
      return this._folders;
    },
    set: function set(folders) {
      this._folders = folders;
      this.updateFoldersMap();
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "configuration",
    get: function get() {
      return this._configuration;
    },
    set: function set(configuration) {
      this._configuration = configuration;
    }
  }, {
    key: "getFolder",
    value: function getFolder(resource) {
      if (!resource) {
        return null;
      }

      return this._foldersMap.findSubstr(resource.with({
        scheme: resource.scheme,
        authority: resource.authority,
        path: resource.path
      })) || null;
    }
  }, {
    key: "updateFoldersMap",
    value: function updateFoldersMap() {
      this._foldersMap = TernarySearchTree.forUris();

      var _iterator = _createForOfIteratorHelper(this.folders),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var folder = _step.value;

          this._foldersMap.set(folder.uri, folder);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        folders: this.folders,
        configuration: this.configuration
      };
    }
  }]);

  return Workspace;
}();
export var WorkspaceFolder = /*#__PURE__*/function () {
  function WorkspaceFolder(data, raw) {
    _classCallCheck(this, WorkspaceFolder);

    this.raw = raw;
    this.uri = data.uri;
    this.index = data.index;
    this.name = data.name;
  }

  _createClass(WorkspaceFolder, [{
    key: "toResource",
    value: function toResource(relativePath) {
      return resources.joinPath(this.uri, relativePath);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        uri: this.uri,
        name: this.name,
        index: this.index
      };
    }
  }]);

  return WorkspaceFolder;
}();